import { useRef } from "react";
import { motion, useInView } from "framer-motion";
import { LOGO_MARK } from "../data/eventData";

// Scroll-reveal wrapper
export const Reveal = ({ children, delay = 0, className = "", y = 36 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

// Masked line reveal (on load / in view)
export const MaskLine = ({ children, delay = 0, className = "", inView = false }) => {
  const ref = useRef(null);
  const seen = useInView(ref, { once: true, margin: "-60px" });
  const play = inView ? seen : true;
  return (
    <span ref={ref} className={`block overflow-hidden ${className}`}>
      <motion.span
        className="block will-change-transform"
        initial={{ y: "115%" }}
        animate={play ? { y: 0 } : { y: "115%" }}
        transition={{ duration: 1.1, delay, ease: [0.22, 1, 0.36, 1] }}
      >
        {children}
      </motion.span>
    </span>
  );
};

// Official 2027 lockup · icon mark + typographic date
export const LogoLockup = ({ size = "md" }) => {
  const imgH = size === "sm" ? "h-8" : size === "lg" ? "h-14" : "h-10";
  const line1 = size === "sm" ? "text-[13px]" : size === "lg" ? "text-xl" : "text-[15px]";
  const line2 = size === "sm" ? "text-[12px]" : size === "lg" ? "text-lg" : "text-[14px]";
  return (
    <span className="flex items-center gap-3 select-none" data-testid="logo-lockup">
      <img src={LOGO_MARK} alt="Pregoeiros Summit" className={`${imgH} w-auto`} />
      <span className="flex flex-col leading-none">
        <span className={`font-display font-black tracking-[0.04em] text-white ${line1}`}>
          PREGOEIROS
        </span>
        <span className={`font-display font-black tracking-[0.04em] ${line2}`}>
          <span className="text-gradient-blue">SUMMIT</span>
          <span className="text-brand-blue font-semibold tracking-[0.02em]"> 2027</span>
        </span>
      </span>
    </span>
  );
};

// Smooth anchor scroll through Lenis when available
export const scrollToId = (hash) => {
  const el = document.querySelector(hash);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

// Linha fina divisória entre seções (padrão G4)
export const SectionDivider = () => (
  <div className="h-px w-full bg-white/[0.07]" aria-hidden="true" />
);
